import {UserCourseRecordedPage} from "@/models/recorded/userCourseRecordedPage";
import {CourseRecordedPage} from "@/models/recorded/courseRecordedPage";
import https from "@/utils/https";
import {Root} from "@/models/root";
import {Method} from "axios-mapper";
import {CourseRecordedCatalog} from "@/models/recorded/courseRecordedCatalog";

export interface UserRecordedPage extends CourseRecordedPage {
  userPage: UserCourseRecordedPage;
}

export interface RecordedContentVO extends CourseRecordedCatalog {
  children: RecordedContentVO[];
  pages: UserRecordedPage[];
}

/**
 * 获取用户录播内容
 * @param courseId
 * @param partId
 */
export const fetchRecordedContent = (courseId: number, partId: number): Promise<Root<RecordedContentVO[]> | null> => {
  return https(true).request<Root<RecordedContentVO[]>>(`/course/user/course/${courseId}/recorded/${partId}/content`, Method.POST)
}

// 选择题提交参数
export interface UserCommitChoiceParam {
  courseId: number;
  partId: number;
  recordedPageId: number;
  answer: string;
}

export interface CodeCommitParam {
  courseId: number;
  partId: number;
  recordedPageId: number;
  code: string;
}

/**
 * 选择题提交
 * @param userCommitChoiceParam
 */
export const commitAnswer = (userCommitChoiceParam: UserCommitChoiceParam): Promise<Root<UserRecordedPage> | null> => {
  return https(true).request<Root<UserRecordedPage>>(
    `/course/user/course/${userCommitChoiceParam.courseId}/recorded/${userCommitChoiceParam.partId}/commitAnswer`,
    Method.PUT,
    {
      recordedPageId: userCommitChoiceParam.recordedPageId,
      answer: userCommitChoiceParam.answer
    })
}

export interface UserCommitExposureParam {
  courseId: number;
  partId: number;
  pageId: number;
  exposureTime: Date;
}

export interface UserCommitUseParam {
  courseId: number;
  partId: number;
  recordedPageId: number;
}

/**
 * 提交素材曝光时间
 * @param userCommitExposureParam
 */
export const commitExposureTime = (userCommitExposureParam: UserCommitExposureParam): Promise<Root<boolean> | null> => {
  return https(true).request<Root<boolean>>(
    `/course/user/course/${userCommitExposureParam.courseId}/recorded/${userCommitExposureParam.partId}/commitExposureTime`,
    Method.PUT,
    {
      time: userCommitExposureParam.exposureTime,
      recordedPageId: userCommitExposureParam.pageId,
    }
  )
}


export interface UserCommitVideoDurationParam {
  courseId: number;
  partId: number;
  recordedPageId: number;
  duration: number;
}

/**
 * 提交视频观看时长
 * @param userCommitVideoDurationParam
 */
export const commitVideoDuration = (userCommitVideoDurationParam: UserCommitVideoDurationParam): Promise<Root<boolean> | null> => {
  return https(true).request<Root<boolean>>(
    `/course/user/course/${userCommitVideoDurationParam.courseId}/recorded/${userCommitVideoDurationParam.partId}/commitVideoDuration`,
    Method.PUT,
    {
      duration: userCommitVideoDurationParam.duration,
      recordedPageId: userCommitVideoDurationParam.recordedPageId
    }
  )
}

/**
 * 用户提交 点击次数/下载次数
 * @param params
 */
export const fetchCommitUseTime = (params: UserCommitUseParam): Promise<Root<boolean> | null> => {
  return https(true).request<Root<boolean>>(
    `/course/user/course/${params.courseId}/recorded/${params.partId}/commitUseTime`,
    Method.PUT,
    {
      "recordedPageId": params.recordedPageId
    }
  )
}

/**
 * 代码提交曝光
 * @param params
 */
export const fetchCodeCommit = (params: CodeCommitParam): Promise<Root<boolean> | null> => {
  return https(true).request<Root<boolean>>(
    `/course/user/course/${params.courseId}/recorded/${params.partId}/codeCommit`,
    Method.PUT,
    {
      code: params.code,
      recordedPageId: params.recordedPageId
    }
  )
}
